import React from 'react';
import './DemoSection.css';

interface DemoSectionProps {
  isMobile: boolean;
}

const DemoSection: React.FC<DemoSectionProps> = ({ isMobile }) => {
  if (!isMobile) return null; // Only show on mobile

  return (
    <section className="demo-section">
      <div className="demo-divider">
        <hr className="demo-line" />
        <span className="demo-text">DEMO AVAILABLE</span>
        <hr className="demo-line" />
      </div>
    </section>
  );
};

export default DemoSection;